import React, { useState, useMemo } from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { Input } from "./ui/input";
import { Search } from "lucide-react";
import { sections } from "../mock";

export default function SearchModal({ open, onClose, onSelect }) {
  const [q, setQ] = useState("");
  const all = useMemo(() => sections.flatMap((s) => s.items), []);
  const results = useMemo(() => {
    if (!q.trim()) return all.slice(0, 12);
    return all.filter((m) => m.title.toLowerCase().includes(q.toLowerCase())).slice(0, 24);
  }, [q, all]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl bg-[#101014] border-white/10 text-white">
        <div className="flex items-center gap-2 mb-3">
          <Search className="w-5 h-5 text-red-500" />
          <Input
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Pesquise em Tv, Filmes, Séries e Novelas"
            className="bg-transparent border-0 focus:ring-0 text-base text-white placeholder:text-white/40"
          />
        </div>
        <div className="max-h-[60vh] overflow-y-auto grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3">
          {results.map((it) => (
            <button
              key={it.id}
              onClick={() => onSelect(it)}
              className="movie-card relative aspect-[2/3] rounded-lg overflow-hidden group bg-[#111]"
            >
              <img src={it.image} alt={it.title} className="w-full h-full object-cover group-hover:scale-105 transition" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
              <p className="absolute bottom-1.5 left-1.5 right-1.5 text-[10px] text-white font-semibold line-clamp-2">{it.title}</p>
            </button>
          ))}
          {results.length === 0 && (
            <p className="col-span-full text-center text-white/50 py-10">Nenhum resultado para “{q}”</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
